import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';

const PopupModal = ({ popup, onClose }) => {
  const [showCloseButton, setShowCloseButton] = useState(false);

  if (!popup || !popup.imageUrl) {
    return null;
  }

  // Construir la URL completa de la imagen
  const apiUrl = import.meta.env.VITE_API_URL;
  let imageUrl = popup.imageUrl;
  
  if (!imageUrl.startsWith('http')) {
    // Asegurar que la URL tenga el formato correcto
    if (!imageUrl.startsWith('/')) {
      imageUrl = `/${imageUrl}`;
    }
    imageUrl = `${apiUrl}${imageUrl}`;
  }

  // Mostrar botón de cerrar después de 3.5 segundos
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowCloseButton(true);
    }, 3500); // 3.5 segundos

    return () => clearTimeout(timer);
  }, []);

  // Cerrar con ESC solo después de que aparezca el botón X
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && showCloseButton) {
        onClose();
      }
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [onClose, showCloseButton]);

  const handleImageClick = () => {
    if (popup.link) {
      window.open(popup.link, '_blank', 'noopener,noreferrer');
    }
  };

  const handleOverlayClick = () => {
    // Solo permitir cerrar haciendo clic en el overlay después de que aparezca el botón X
    if (showCloseButton) {
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
      {/* Overlay con fondo oscuro - solo cierra si ya apareció el botón X */}
      <div
        className={`absolute inset-0 bg-black/70 backdrop-blur-sm transition-opacity ${
          showCloseButton ? 'cursor-pointer' : 'cursor-default'
        }`}
        onClick={handleOverlayClick}
      />

      {/* Contenedor del pop-up */}
      <div className="relative z-10 w-full max-w-5xl max-h-[95vh] flex flex-col animate-in fade-in zoom-in duration-300">
        {/* Botón cerrar - aparece después de 3.5 segundos */}
        {showCloseButton && (
          <button
            onClick={onClose}
            className="absolute -top-12 right-0 text-white hover:text-gray-200 transition-all z-20 p-2 rounded-full hover:bg-white/20 animate-in fade-in duration-300"
            aria-label="Cerrar pop-up"
          >
            <X size={32} className="bg-black/50 rounded-full p-1.5" />
          </button>
        )}

        {/* Contenido del pop-up - Solo imagen */}
        <div className="bg-transparent rounded-xl shadow-2xl overflow-hidden flex flex-col max-h-[95vh]">
          <div className="relative flex-1 overflow-auto flex items-center justify-center bg-transparent min-h-[300px]">
            <img
              src={imageUrl}
              alt={popup.title || 'Pop-up'}
              className={`max-w-full max-h-[90vh] w-auto h-auto object-contain ${
                popup.link ? 'cursor-pointer hover:opacity-95 transition-opacity' : ''
              }`}
              onClick={handleImageClick}
              onError={(e) => {
                // Mostrar mensaje de error
                const errorDiv = document.createElement('div');
                errorDiv.className = 'p-8 text-center text-red-500 bg-white rounded-lg';
                errorDiv.textContent = 'Error al cargar la imagen';
                e.target.parentNode.replaceChild(errorDiv, e.target);
              }}
              style={{ display: 'block' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopupModal;

